import { useQuery } from "@apollo/client";
import {
  UseFeatureSwitchesDocument
} from "./feature-switches-query.gql-types";
function useFeatureSwitches(flags) {
  var _a;
  const { data } = useQuery(UseFeatureSwitchesDocument, {
    fetchPolicy: "cache-first"
  });
  const featureSwitches = ((_a = data == null ? void 0 : data.viewer) == null ? void 0 : _a.featureSwitches) || [];
  if (flags) {
    return flags.every((flag) => featureSwitches.includes(flag));
  }
  return featureSwitches;
}
export {
  useFeatureSwitches
};
